/**
 * region for libraries*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

/**
 * region for styles*/
import { headerTitleStyle } from './style/headerTitleStyle';

class HeaderTitle extends Component {
    render() {
        const { classes, title } = this.props;
        return (
            <Typography className={classes.title}
                component="h1"
                variant="h6"
                color="inherit"
                noWrap>
                {title}
            </Typography>
        );
    }
}
HeaderTitle.propTypes = {
    classes: PropTypes.object.isRequired
};
export default withStyles(headerTitleStyle)(HeaderTitle);